<template lang="pug">
.bq-landing
    main
        section#what.bq-hero
            .bq-hero-landing-bunny
                BunnyLoader(:overlay="false")
            h1 BunnyQuery
            p Secure AI Chat for #[span.wordset Your Business Data]
            p.bq-hero-body Use ChatGPT, Claude, and other AI models with #[span.wordset your own data] to generate reports, #[span.wordset summarize documents,] forecast sales, automate workflows, #[span.wordset answer customer questions,] #[span.wordset and uncover business insights] #[span.wordset securely and instantly.]
            p Turn your data into smarter decisions #[span.wordset with BunnyQuery.]
            br
            .bq-hero-body
                router-link.bq-btn(
                    data-track="landing_bq_hero_signup",
                    :to="user?.user_id ? '/my-projects' : '/signup'"
                ) Try BunnyQuery &rarr;

        section#how.bq-section.bq-section--alt
            .bq-section-header
                span.bq-pill HOW IT WORKS
                h2 AI That Knows #[span.wordset Your Context.]
            .bq-infra-grid
                .bq-step
                    .bq-step-num 1
                    h3 Give your AI context
                    p Create a project and upload documents, spreadsheets, images, reports, notes, or business data. BunnyQuery organizes your context.
                .bq-step
                    .bq-step-num 2
                    h3 Ask your AI
                    p Chat with your data. Get summaries, reports, charts, CSV files, #[span.wordset document drafts,] and recommendations based on #[span.wordset your data.]
                .bq-step
                    .bq-step-num 3
                    h3 Share your AI
                    p Invite teammates, clients, or customers to ask questions directly. #[span.wordset Let them get context-aware] answers without waiting on you.

        section#why.bq-section.bq-hero
            .bq-section-header
                span.bq-pill WHY BUNNYQUERY
                h2 Your data, #[span.wordset your AI,] #[span.wordset your rules.]
                p.bq-section-sub Your data is your #[span.wordset most valuable asset.]#[br]BunnyQuery's secure context database keeps it safe and within reach.
            .bq-reasons
                .bq-reason
                    span.bq-reason-num A
                    .bq-reason-body
                        span.bq-reason-title Data ownership by design
                        p You decide who can view your files and data. You can safely share your AI chats with teammates, clients, or customers.
                .bq-reason
                    span.bq-reason-num B
                    .bq-reason-body
                        span.bq-reason-title Your data stays yours
                        p Your data is not tied to one AI model or provider. Use ChatGPT, Claude, or other AI models with the same business context.
                .bq-reason
                    span.bq-reason-num C
                    .bq-reason-body
                        span.bq-reason-title Built for collaboration
                        p Let others ask questions, generate reports, and find answers from approved data without sending you repetitive messages.

        section#cases.bq-section.bq-section--alt
            .bq-section-header
                span.bq-pill USE CASES
                h2 AI assistant for your data and workflows.
            .bq-cases
                article.bq-case
                    .bq-case-head
                        span.bq-case-id 001
                        h3 Finance assistant
                    p Analyze receipts, invoices, contracts, statements, and reports. Generate charts, summaries, forecasts, and financial insights from your own data.
                    .bq-case-prompt
                        span.bq-prompt-chr &gt;
                        code Show income by month with a chart of revenue sources.
                article.bq-case
                    .bq-case-head
                        span.bq-case-id 002
                        h3 Business knowledge AI
                    p Turn client notes, strategy docs, product information, and internal processes into knowledge your teammates can query instead of asking you.
                    .bq-case-prompt
                        span.bq-prompt-chr &gt;
                        code Who is our biggest client and what do they want?
                article.bq-case
                    .bq-case-head
                        span.bq-case-id 003
                        h3 Personal health assistant
                    p Keep medical results, prescriptions, and health records in one secure AI workspace. Track progress, compare results, and prepare for doctor visits.
                    .bq-case-prompt
                        span.bq-prompt-chr &gt;
                        code Show how my blood sugar levels have changed over time.
                article.bq-case
                    .bq-case-head
                        span.bq-case-id 004
                        h3 Research and document analysis
                    p Ask questions across PDFs, papers, reports, manuals, and reference materials. Summarize, compare, and extract insights instantly.
                    .bq-case-prompt
                        span.bq-prompt-chr &gt;
                        code Summarize the key findings from these research papers.

        section#dev.bq-section.bq-hero
            .bq-section-header
                span.bq-pill FOR DEVELOPERS
                br
                SkapiBunnyLockup
                h2 MCP-ready #[span.wordset AI infrastructure] #[span.wordset for your data.]
                p.bq-section-sub Connect your data once, then use it across the AI platforms and tools you already trust.
            .bq-infra-grid
                .bq-infra-card
                    h3 MCP Connectivity
                    p Connect your project's context database to any AI platforms that supports MCP.
                    p.bq-section-link
                        a(href="https://mcp.broadwayinc.computer" target="_blank" rel="noopener") mcp.broadwayinc.computer &rarr;
                .bq-infra-card
                    h3 Built on Skapi
                    p Secure data handling on serverless infrastructure that scales with zero downtime.
                    p.bq-section-link
                        a(href="https://www.skapi.com" target="_blank" rel="noopener") www.skapi.com &rarr;
                .bq-infra-card
                    h3 Custom Development
                    p Every BunnyQuery project is ready for custom development. Build your own web apps on the same data.
                    p.bq-section-link
                        a(href="https://docs.skapi.com" target="_blank" rel="noopener") docs.skapi.com &rarr;
        section.bq-section--alt
            .bq-footer-cta
                .bq-landing-bunny
                    BunnyLoader(:overlay="false")
                h2 Try BunnyQuery #[span.wordset for Free]
                p Free to start. No credit card. #[span.wordset Your data, your AI.]
                
                router-link.bq-btn(
                    data-track="landing_bq_bottom_services",
                    :to="user?.user_id ? '/my-projects' : '/signup'"
                ) Try BunnyQuery &rarr;
</template>

<script setup>
import { user } from "@/code/user";
import BunnyLoader from "@/components/bunnyLoader.vue";
import SkapiBunnyLockup from "@/components/skapiBunnyLockup.vue";
import { removeFullScreenLoader } from "@/components/jsComponents";
import { onMounted } from "vue";

onMounted(() => {
    removeFullScreenLoader();
});
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

.bq-landing {
    min-height: 100vh;
    margin: 0;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 15px;
    line-height: 1.7;
    overflow-x: hidden;

    button {
        all: unset;
        box-sizing: border-box;
        cursor: pointer;

        &::after {
            display: none;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-weight: inherit;
    }

    hr {
        background: @line;
    }
}

/* ─── hero ─── */
.bq-hero {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 2rem 5rem;
    border-bottom: 1px solid @line;

    h1 {
        margin: 0.75rem 0 1.5rem;
        font-size: clamp(2.6rem, 5vw, 4.4rem);
        line-height: 1.08;
        font-weight: 700;
        text-shadow: 2px 2px rgba(0, 0, 0, 0.12);
    }
}

.bq-hero-body {
    margin: 0 0 2rem;
    color: @muted;
    max-width: 800px;
}
.bq-hero-landing-bunny {
    margin: 0 0 0.75rem;
    width: 100%;
    position: relative;

    :deep(.bq-bunny-loader) {
        align-items: flex-start;
    }

    :deep(.bq-bunny-stage) {
        width: 100%;
        overflow: hidden;
    }

    :deep(.bq-bunny-track) {
        height: 8rem;
        animation-name: bq-hero-bunny-move;
    }
}

@keyframes bq-hero-bunny-move {
    0%     { transform: translateX(0ch); }
    25%    { transform: translateX(22ch); }
    37.5%  { transform: translateX(22ch); }
    50%    { transform: translateX(22ch); }
    75%    { transform: translateX(0ch); }
    87.5%  { transform: translateX(0ch); }
    100%   { transform: translateX(0ch); }
}

/* ─── button ─── */
.bq-btn {
    display: inline-block;
    padding: 0.85rem 1.6rem;
    border: 1px solid @ink;
    background: @ink;
    color: @paper;
    font: inherit;
    font-size: 0.9rem;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    box-shadow: 2px 2px rgba(0, 0, 0, 0.12);

    &:hover {
        background: @paper;
        color: @ink;
        text-decoration: none;
    }
}

/* ─── sections ─── */
.bq-section {
    max-width: 1200px;
    margin: 0 auto;
    padding: 5rem 2rem;
}

.bq-section--alt {
    background: color-mix(in srgb, @ink 2%, @paper);
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;

    .bq-section-header,
    .bq-reasons,
    .bq-cases,
    .bq-infra-grid {
        max-width: 1200px;
        margin-left: auto;
        margin-right: auto;
        padding-left: 2rem;
        padding-right: 2rem;
    }
}

.bq-section-header {
    margin-bottom: 3rem;

    h2 {
        margin: 0 0 0.75rem;
        font-size: clamp(1.6rem, 3.5vw, 2.6rem);
        line-height: 1.15;
        font-weight: 600;
        // max-width: 44rem;
        text-shadow: 2px 2px rgba(0, 0, 0, 0.12);
    }
}

.bq-pill {
    display: inline-block;
    padding: 0.3rem 0.7rem;
    margin-bottom: 1rem;
    font-size: 0.72rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    border: 1px solid @pink;
    color: @pink;
}

.bq-section-sub {
    margin: 0;
    color: @muted;
    max-width: 800px;
}

.bq-section-link {
    margin: 1rem 0 0;
    font-size: 0.9rem;

    a {
        color: @pink;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
}

/* ─── steps ─── */
.bq-step {
    padding: 1.25rem 1.5rem 1.4rem;
    border: 1px solid @line;
    background: @paper;
    h3 {
        margin: 0 0 0.4rem;
        font-size: 1rem;
    }

    p {
        margin: 0;
        color: @muted;
        font-size: 0.88rem;
        line-height: 1.55;
    }
}

.bq-step-num {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 0.65rem;
    color: @muted;
}

/* ─── reasons ─── */
.bq-reasons {
    display: grid;
    gap: 0;
}

.bq-reason {
    display: flex;
    gap: 1.25rem;
    align-items: baseline;
    border-bottom: 1px solid @line;
    padding: 1.5rem 0;

    &:first-child {
        border-top: 1px solid @line;
    }

    p {
        margin: 0.35rem 0 0;
        color: @muted;
        font-size: 0.92rem;
    }
}

.bq-reason-num {
    font-weight: 700;
    font-size: 0.85rem;
    min-width: 1.5rem;
    flex-shrink: 0;
}

.bq-reason-body {
    flex: 1;
    min-width: 0;
}

.bq-reason-title {
    display: block;
    font-weight: 600;
    font-size: 1.05rem;
}

/* ─── infra ─── */
.bq-infra-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
}

.bq-infra-card {
    padding: 1.5rem;
    border: 1px solid @line;
    box-shadow: 2px 2px rgba(0, 0, 0, 0.12);
    h3 {
        margin: 0 0 0.5rem;
        font-size: 1rem;
    }

    p {
        margin: 0;
        color: @muted;
        font-size: 0.92rem;
    }
}

/* ─── cases ─── */
.bq-cases {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
}

.bq-case {
    display: flex;
    flex-direction: column;
    border: 1px solid @line;
    padding: 1.5rem;
    background: @paper;
    > p {
        margin: 0 0 1rem;
        color: @muted;
        font-size: 0.92rem;
        flex: 1;
    }
}

.bq-case-head {
    display: flex;
    gap: 1rem;
    align-items: baseline;
    margin-bottom: 0.6rem;

    h3 {
        margin: 0;
        font-size: 1.05rem;
    }
}

.bq-case-id {
    font-weight: 700;
    font-size: 0.8rem;
    color: @muted;
    min-width: 2.5rem;
}

.bq-case-prompt {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.7rem 1rem;
    background: @pink-bg;
    border: 1px solid @line;
    color: @ink;
    font-size: 0.85rem;
    line-height: 1.5;

    code {
        font-family: @mono;
        background: none;
        padding: 0;
    }
}

.bq-prompt-chr {
    color: @light-pink;
    font-size: 1rem;
    flex-shrink: 0;
    line-height: 1;
}

/* ─── plans ─── */

/* ─── footer cta ─── */
.bq-footer-cta {
    max-width: 1200px;
    margin: 0 auto;
    padding: 5rem 1.5rem;
    text-align: center;

    h2 {
        margin: 0 0 0.75rem;
        font-size: clamp(1.8rem, 4vw, 2.8rem);
        font-weight: 700;
        text-shadow: 2px 2px rgba(0, 0, 0, 0.12);
    }

    p {
        margin: 0 0 2rem;
        color: @muted;
    }
}

/* ─── bunny animation ─── */
.bq-landing-bunny {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1rem;
}

/* ─── responsive ─── */
@media (max-width: 900px) {
    .bq-hero {
        padding: 1rem 1.5rem 3rem;
    }

    .bq-hero .bq-btn,
    .bq-footer-cta .bq-btn {
        display: block;
        width: 100%;
        text-align: center;
    }

    .bq-infra-grid {
        grid-template-columns: 1fr;
    }

    .bq-cases {
        grid-template-columns: 1fr;
    }

    .bq-section {
        padding: 3rem 1.5rem;
    }

    .bq-section--alt {
        padding-left: 0;
        padding-right: 0;

        .bq-section-header,
        .bq-reasons,
        .bq-cases,
        .bq-infra-grid {
            padding-left: 1.5rem;
            padding-right: 1.5rem;
        }
    }

    .bq-case-head {
        flex-direction: column;
        gap: 0.5rem;
    }

    .bq-section-header {
        margin-bottom: 2rem;
    }
}

@media (max-width: 500px) {
    .bq-hero h1 {
        font-size: 3rem;
    }

    .bq-reason p {
        padding-left: 0;
    }

    .bq-reason {
        flex-direction: column;
        gap: 0.25rem;
    }
}
</style>
